import { CHECKBOX } from 'enums';
import React from 'react';
import COLOR from 'constants/color';
import Tooltip from './Tooltip';
import { t } from 'services/i18n.service';
import ButtonExpressInterest from './buttons/ButtonExpressInterest';
import { POST_HOG_EVENT } from 'constants/events';

interface CheckBoxProps
  extends
    React.DetailedHTMLProps<
      React.InputHTMLAttributes<HTMLInputElement>,
      HTMLInputElement
    >,
    React.Attributes {
  label?: string | JSX.Element;
  inputStyles?: string;
  labelStyles?: string;
  position?: number;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    position?: number
  ) => void;
  tooltipMessage?: string;
}

const CheckBox: React.FC<CheckBoxProps> = ({
  label,
  inputStyles = 'cursor-pointer outline-none accent-green-300',
  labelStyles,
  type,
  onChange,
  position,
  tooltipMessage,
  ...rest
}) => {
  const isCustomTimeLabel = label === t('routine_suggestion.custom_timing');
  return (
    <label
      className={`${labelStyles ?? 'min-w-max ~text-xs/sm w-fit flex items-center flex-wrap ~gap-1/1.5 cursor-pointer'}`}>
      <input
        className={inputStyles}
        type={type ?? CHECKBOX.DEFAULT}
        onChange={(event) => onChange?.(event, position)}
        {...rest}
      />
      <span className={isCustomTimeLabel ? 'min-w-max' : ''}>{label}</span>
      {isCustomTimeLabel && (
        <div className='flex flex-col items-center'>
          <ButtonExpressInterest
            eventName={
              POST_HOG_EVENT.ROUTINE_SUGGESTIONS_CUSTOM_TIMING_EXPRESS_INTEREST_BUTTON_CLICKED
            }
          />
          <small className='~text-sm/base text-primary-300 mt-auto cursor-default'>{`(${t('inquiry.coming_soon')})`}</small>
        </div>
      )}
      {tooltipMessage && (
        <Tooltip
          message={tooltipMessage}
          iconStyles='~w-4/5 ~h-4/5 inline-flex ml-1'
          additionalWrapperStyles='w-fit'
          iconFillDarkMode={COLOR.WHITE}
        />
      )}
    </label>
  );
};

export default CheckBox;
